import './Body.css';

function Body() {
    return (
            <div className="pic-container">
                <article className="pic-container-inner">
                    <header className="pic-header">Employee Portal</header>
                    <p className="pic-explanation">Description</p>
                </article>
            </div>
    );
}

export default Body;